import createReactComponent from '../createReactComponent';
export default createReactComponent('divide', 'Divide', [["path",{"d":"M3 12h18m-9-6.256V5m0 14v-.744","key":"svg-0"}]]);